import { useState } from 'react'
import { Button, Spinner, Tooltip } from '@fluentui/react-components'
import { useCompleteProjectForecastReports } from '../../../Projektprognos/fetchData/mutations/useCompleteProjectForecastReports'
import { ActionConfirmationModal } from '../../../Projektprognos/Snapshots/Shared/ActionConfirmationModal'
import { ProjectForecastReportPeriod } from '../../../../interfaces/systemSettings/ProjectForecastReport'
import styles from './CompleteProjectForecastReportsButton.module.css'

interface CompleteProjectForecastReportsButtonProps {
  year: number
  period: ProjectForecastReportPeriod
}

const CompleteProjectForecastReportsButton = ({
  year,
  period,
}: CompleteProjectForecastReportsButtonProps) => {
  const { mutate, isPending, error, reset } = useCompleteProjectForecastReports(
    year,
    period
  )
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpen = () => {
    reset()
    setIsModalOpen(true)
  }

  const handleClose = () => {
    reset()
    setIsModalOpen(false)
  }

  const handleConfirm = () => {
    mutate(undefined, {
      onSuccess: () => {
        setIsModalOpen(false)
      },
    })
  }

  return (
    <>
      <Tooltip
        content={`Färdigställ samtliga pågående rapporter för ${period} ${year}`}
        relationship="label"
      >
        <Button
          className={styles.button}
          onClick={handleOpen}
          disabled={isPending}
          appearance="secondary"
        >
          {isPending && <Spinner size="tiny" className={styles.spinner} />}
          Färdigställ period
        </Button>
      </Tooltip>

      <ActionConfirmationModal
        isOpen={isModalOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isPending}
        error={error}
        onReset={reset}
        title="Färdigställ period"
        message={`Du är på väg att färdigställa samtliga pågående prognosrapporter för ${period} ${year}. Rapporterna låses för redigering och detta kan inte ångras. Är du säker?`}
        confirmLabel="Färdigställ"
      />
    </>
  )
}

export default CompleteProjectForecastReportsButton
